import {
	Vector3,
	Box3,
} from 'three';

import {IomoLuminaire} from './iomoLuminaire';

class IomoPoleLuminaire extends IomoLuminaire {
	static designName = 'pole';

	static poleSizes = {
		cylindrical__4__114: {
			height: 4,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__4__140: {
			height: 4,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__4__159: {
			height: 4,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		cylindrical__5__114: {
			height: 5,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__5__140: {
			height: 5,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__5__159: {
			height: 5,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		cylindrical__6__114: {
			height: 6,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__6__140: {
			height: 6,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__6__159: {
			height: 6,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		cylindrical__7__114: {
			height: 7,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__7__140: {
			height: 7,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__7__159: {
			height: 7,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		cylindrical__8__114: {
			height: 8,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__8__140: {
			height: 8,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__8__159: {
			height: 8,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		cylindrical__9__114: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.114,
			bottomDiameter: 0.114
		},
		cylindrical__9__140: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.1397,
			bottomDiameter: 0.1397
		},
		cylindrical__9__159: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.159,
			bottomDiameter: 0.159
		},

		conical__4__76: {
			height: 4,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.120
		},
		conical__5__76: {
			height: 5,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.131
		},
		conical__6__76: {
			height: 6,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.142
		},
		conical__7__76: {
			height: 7,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.153
		},
		conical__8__76: {
			height: 8,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.164
		},
		conical__9__76: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.175
		},
		conical__10__76: {
			height: 10,
			topMargin: 0.25,
			topDiameter: 0.076,
			bottomDiameter: 0.186
		},
		conical__9__89: {
			height: 9,
			topMargin: 0.25,
			topDiameter: 0.089,
			bottomDiameter: 0.188
		},
		conical__10__89: {
			height: 10,
			topMargin: 0.25,
			topDiameter: 0.089,
			bottomDiameter: 0.199
		},
	};

	static poleConstraints = {
		conical: {
			poleHeight: [4, 5, 6, 7, 8, 9, 10],
			poleDiameter: {
				4: [76],
				5: [76],
				6: [76],
				7: [76],
				8: [76],
				9: [76, 89],
				10: [76, 89],
			},
		},
		cylindrical: {
			poleHeight: [4, 5, 6, 7, 8, 9],
			poleDiameter: {
				4: [114, 140, 159],
				5: [114, 140, 159],
				6: [114, 140, 159],
				7: [114, 140, 159],
				8: [114, 140, 159],
				9: [114, 140, 159],
			},
		}
	};
	static models = {
		pole: {},
		bracket: {},
	};

	static modelPatterns = [
		{
			type: 'pole',
			pattern: /^Pole_(?<shape>(conical)|(cylindrical))_(?<height>[0-9]+)_(?<diameter>[0-9]+)$/i,
			storageKeys: ['shape', 'height', 'diameter']
		},

		{type: 'bracket', pattern: /^(?<id>[0-9]+)_Bracket$/i, storageKeys: ['id']},
	];

	static headLinkOffsets = {};
	static internalOffsets = null;

	static defaultConfig = {
		design: 'pole',
		poleHeight: 9,
		poleDiameter: '140',
		poleShape: 'cylindrical',

		numberOfHeads: 8,
		layout: 'spiral',
		heightMax: 10.00,
		heightMin: 4.00,
		angleMax: 360,
		angleMin: 0,
		environment: 'day',

		bracket: '195',
		housingSize: '195',
		opticalSystem: 'Comfort',
		colourTemperature: '3000K',
		lightDistribution: '45',
		reflectorColour: 'gold',
		cap: 'short', // short, long, asymmetric
		modifier: 'none', // none, honeycomb
	};


	static getPoleId(configValues) {
		return String(configValues.poleShape + this.conf.keySep + configValues.poleHeight + this.conf.keySep + configValues.poleDiameter);
	}

	static getBracketId(configValues, index) {
		return configValues.bracket.match(/[0-9]+/)[0];
	}

	static calculateLaValue(poleHeight, actualHeight) {
		return poleHeight - actualHeight;
	}


	getBracketCollisionBoxInfo(configValues, bracket, bracketMesh) {
		const self = this.constructor;
		let bracketOffset = null;
		let bracketSize = null;
		const bracketBox = new Box3();
		bracketBox.setFromObject(bracket);
		bracketSize = new Vector3();
		const plane = new Box3(
			new Vector3(bracketBox.min.x + 0.005, bracketBox.min.y, bracketBox.min.z),
			new Vector3(bracketBox.min.x + 0.04, bracketBox.min.y + 0.12, bracketBox.max.z)
		);
		bracketBox.intersect(plane);
		bracketBox.getSize(bracketSize);
		bracketOffset = new Vector3();
		bracketBox.getCenter(bracketOffset);
		bracketOffset.x -= bracketMesh.position.x;
		return {bracketOffset: bracketOffset, bracketSize: bracketSize};
	}


}


for (const id of Object.keys(IomoPoleLuminaire.poleSizes)) {
	const entry = IomoPoleLuminaire.poleSizes[id];
	const h = entry.height - entry.topMargin;
	entry.xBaseOffset = (entry.topDiameter / 2);
	const b = (entry.bottomDiameter / 2) - entry.xBaseOffset;
	entry.ratio = b / h;
	entry.maxHeight = h;
	const i = Math.sqrt(h**2 + b**2);
	entry.verticalAngle = Math.asin(b / i) * (180 / Math.PI); // deg
}


export {IomoPoleLuminaire};

